import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import brand from '@brand/brand.json'
import ar from './ar.json'
import arIdentity from './ar.identity.json'
import arSettings from './ar.settings.json'
import arCatalog from './ar.catalog.json'
import arMoney from './ar.money.json'
import arPos from './ar.pos.json'
import arPromotions from './ar.promotions.json'
import arReports from './ar.reports.json'
import arSalespeople from './ar.salespeople.json'
import arSales from './ar.sales.json'
import arCustomers from './ar.customers.json'
import en from './en.json'
import enIdentity from './en.identity.json'
import enSettings from './en.settings.json'
import enCatalog from './en.catalog.json'
import enMoney from './en.money.json'
import enPos from './en.pos.json'
import enPromotions from './en.promotions.json'
import enReports from './en.reports.json'
import enSalespeople from './en.salespeople.json'
import enSales from './en.sales.json'
import enCustomers from './en.customers.json'

// One JSON file per area keeps translation files small; they merge into one namespace.
export const resources = {
  ar: { translation: { ...ar, ...arIdentity, ...arSettings, ...arCatalog, ...arMoney, ...arPos, ...arPromotions, ...arReports, ...arSalespeople, ...arSales, ...arCustomers } },
  en: { translation: { ...en, ...enIdentity, ...enSettings, ...enCatalog, ...enMoney, ...enPos, ...enPromotions, ...enReports, ...enSalespeople, ...enSales, ...enCustomers } },
} as const

void i18n.use(initReactI18next).init({
  resources,
  lng: brand.locale,
  fallbackLng: 'ar',
  interpolation: { escapeValue: false },
})

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng
  document.documentElement.dir = i18n.dir(lng)
})

export default i18n
